import Immutable from "immutable";

import { QuestionsPageAction } from "components/Pages/Questions/types";
import { ResponseEditorTrainerPageAction } from "./types";

export class ResponseEditorTrainerPageState extends Immutable.Record({
  newPhrase: "",
  canLoadMore: false,
  expressionsCount: 0,
  addingExpression: false
}) {}

export const responseEditorTrainerPage = (
  state = new ResponseEditorTrainerPageState(),
  action: ResponseEditorTrainerPageAction | QuestionsPageAction
): ResponseEditorTrainerPageState => {
  switch (action.type) {
    case "SET_RESPONSE_EDITOR_TRAINER_PAGE":
      return state.merge(action.payload);

    case "GET_TRAINED_EXPRESSIONS_SUCCESS":
      return state.merge({
        canLoadMore: action.response.data.expressions.length === 10
      });

    case "GET_TRAINED_EXPRESSIONS_COUNT_SUCCESS":
      return state.merge({ expressionsCount: action.response.data.count });

    case "TRAIN_EXPRESSION_REQUEST":
    case "MOVE_EXPRESSION_REQUEST":
    case "CREATE_EXPRESSION_REQUEST":
      return state.set("addingExpression", true);

    case "TRAIN_EXPRESSION_SUCCESS":
    case "MOVE_EXPRESSION_SUCCESS":
    case "CREATE_EXPRESSION_SUCCESS":
      return state.merge({
        newPhrase: "",
        expressionsCount: state.get("expressionsCount") + 1,
        addingExpression: false
      });

    case "TRAIN_EXPRESSION_FAILURE":
    case "MOVE_EXPRESSION_FAILURE":
    case "CREATE_EXPRESSION_FAILURE":
      return state.merge({
        newPhrase: "",
        addingExpression: false
      });

    case "DELETE_EXPRESSION_SUCCESS":
      return state.merge({ expressionsCount: state.get("expressionsCount") - 1 });

    case "CLEAR_PHRASE":
      return state.set("newPhrase", "");

    case "CREATE_EXPRESSIONS_SUCCESS": {
      const newExpressionsCount = (
        state.get("expressionsCount") + action.response.data.created_expressions.length
      );

      return state.merge({
        newPhrase: "",
        expressionsCount: newExpressionsCount,
        addingExpression: false
      });
    }

    case "MOVE_ALL_EXPRESSIONS_SUCCESS": {
      // after moving all, the only expressions remaining are those that had errors
      const newExpressionsCount = action.response.data.errors.length;

      return state.merge({ expressionsCount: newExpressionsCount });
    }

    case "MOVE_EXPRESSIONS_SUCCESS": {
      const newExpressionsCount = state.get("expressionsCount") - action.response.data.updated_expressions.length;

      return state.merge({ expressionsCount: newExpressionsCount });
    }

    case "DELETE_EXPRESSIONS_SUCCESS": {
      const newExpressionsCount = state.get("expressionsCount") - action.response.data.deleted_expressions.length;

      return state.merge({ expressionsCount: newExpressionsCount });
    }

    default:
      return state;
  }
};
